module.exports = __webpack_public_path__ + "static/img/no-empty.f6646dd4.png";